import React from "react";

const CoverPage = ({ imageSrc, altText = "Cover Image" }) => {
  return (
    <>
      {/* Inline CSS for Mobile Optimization */}
      <style>
        {`
          @media (max-width: 768px) {
            .cover-image {
              height: 60vh !important;
              object-fit: cover;
              object-position: center;
            }
          }
        `}
      </style>

      <section className="bg-dark text-light d-flex align-items-center justify-content-center">
        <div className="container-fluid p-0">
          <div className="row g-0">
            <div className="col-12">
              <img
                className="img-fluid w-100 cover-image"
                src={imageSrc}
                alt={altText}
                style={{
                  height: "100vh",
                  objectFit: "cover",
                  objectPosition: "center",
                }}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CoverPage;
